<template>
    <v-layout column class="cff-fees">
        <v-flex>
            <h4>CFF Fees</h4>
        </v-flex>
        <v-flex pa-3 class="panelBlock form-control">
            <v-flex v-for="(cff, i) in filterKeys" :key="i">
                <v-layout column :class="[i > 0 ? 'mt-3' : '']">
                    <v-flex>
                        <label>{{ cff.label }}</label>
                    </v-flex>
                </v-layout>
                <v-layout mt-1 pb-2 row wrap class="cff-fees__column">
                    <v-flex xs6 pr-2>
                        <v-select
                            :class="[notAValidMinFee(cff.minFee, cff.maxFee) ? 'cff-fees__error' : '']"
                            :items="minFeeRange"
                            v-model="cff.minFee"
                            label="Min"
                            item-text="name"
                            item-value="value"
                            @change="feeChange(cff.minKey, cff.minFee, cff.maxKey, cff.maxFee)"
                            solo
                            flat
                            hide-details
                            data-qe-id="cffFeeRangeMin"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 pl-2>
                        <v-select
                            :class="[notAValidMaxFee(cff.minFee, cff.maxFee) ? 'cff-fees__error' : '']"
                            :items="maxFeeRange"
                            v-model="cff.maxFee"
                            label="Max"
                            item-text="name"
                            item-value="value"
                            @change="feeChange(cff.minKey, cff.minFee, cff.maxKey, cff.maxFee)"
                            solo
                            flat
                            hide-details
                            data-qe-id="cffFeeRangeMax"
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { storeAction } from '../../store/storeActions.constant';

export default {
    name: 'SearchSpeakerCffFee',
    props: {
        applySpeakerFilter: {
            type: Function,
            required: true,
        },
    },
    data: () => ({
        maxFeeRange: [],
        minFeeRange: [],
        filterKeys: [
            {
                minKey: 'ForumTrainingMinFee',
                maxKey: 'ForumTrainingMaxFee',
                minFee: '',
                maxFee: '',
                label: 'YPO Forum Training',
            },
            {
                minKey: 'SuperchargeMinFee',
                maxKey: 'SuperchargeMaxFee',
                minFee: '',
                maxFee: '',
                label: 'YPO Supercharge',
            },
            {
                minKey: 'RetreatMinFee',
                maxKey: 'RetreatMaxFee',
                minFee: '',
                maxFee: '',
                label: 'YPO Retreat',
            },
        ],
    }),
    created() {
        this.getFeesRange().then((response) => {
            this.minFeeRange = [{ name: 'Min', value: '' }, ...response.data.minRanges.map(r => ({ name: r, value: r }))];
            this.maxFeeRange = [{ name: 'Max', value: '' }, ...response.data.maxRanges.map(r => ({ name: r, value: r }))];
        });
        this.checkSpeakersCFFFilter();
    },
    methods: {
        ...mapActions({
            getFeesRange: `speaker/${storeAction.getFeesRange}`,
        }),
        notAValidMinFee(minFee, maxFee) {
            return (maxFee !== '' && minFee > maxFee) || (maxFee !== '' && minFee === '');
        },
        notAValidMaxFee(minFee, maxFee) {
            return (minFee !== '' && maxFee < minFee) || (minFee !== '' && maxFee === '');
        },
        feeChange(minFeeKey, minFee, maxFeeKey, maxFee) {
            if (!this.notAValidMinFee(minFee, maxFee) && !this.notAValidMaxFee(minFee, maxFee)) {
                const queryParams = {};
                this.removeInvalidRangeFromRoute(this.$route.query);
                queryParams[`${minFeeKey}`] = minFee;
                queryParams[`${maxFeeKey}`] = maxFee;
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        ...queryParams,
                    },
                });
            }
        },
        checkSpeakersCFFFilter() {
            this.filterKeys.forEach((key) => {
                if (
                    this.$route.query[key.minKey] !== undefined &&
                    this.$route.query[key.maxKey] !== undefined &&
                    this.$route.query[key.minKey] !== '' &&
                    this.$route.query[key.maxKey] !== '' &&
                    !this.notAValidMinFee(this.$route.query[key.minKey], this.$route.query[key.maxKey]) &&
                    !this.notAValidMaxFee(this.$route.query[key.minKey], this.$route.query[key.maxKey])
                ) {
                    this.applySpeakerFilter([
                        {
                            label: key.minKey,
                            filterKey: key.minKey,
                            filterValue: this.$route.query[key.minKey],
                        },
                        {
                            label: key.maxKey,
                            filterKey: key.maxKey,
                            filterValue: this.$route.query[key.maxKey],
                        },
                    ]);

                    key.minFee = Number(this.$route.query[key.minKey]);
                    key.maxFee = Number(this.$route.query[key.maxKey]);
                }
            });
        },
        removeInvalidRangeFromRoute(queryParams) {
            this.filterKeys.forEach((key) => {
                if (this.notAValidMinFee(key.minFee, key.maxFee) && this.notAValidMaxFee(key.minFee, key.maxFee)) {
                    delete queryParams[key.minKey];
                    delete queryParams[key.maxKey];
                }
            });
        },
    },
    computed: {
        ...mapState('actionState', ['actions']),
    },
};
</script>
